
import { useInView } from "react-intersection-observer";
import { useNavigate } from "react-router";

function CloudStackDevelopmentPageDescription(props: any) {
    const { description, imagePosition, altText } = props;
    const { ref, inView } = useInView({
        // triggerOnce: true,
        threshold: 0,
    });
    let navigate = useNavigate();

    const buttonLink = description?.ButtonText?.includes("#")
        ? description?.ButtonText?.split("#")
        : null;

    return (
        <div className="bg-[white]">
            <div className="px-5 py-7 bg-[#12121] relative lg:px-10 text-black-75 xl:px-20 lg:py-20  max-w-screen-2xl lg:mx-auto text-black-75 flex-col flex xl:flex-row lg:justify-center gap-[5%]">

                <div ref={ref} className="xl:w-1/2 flex flex-col justify-center">

                    <div className="rounded-full py-1.5 px-4 bg-white text-sm border border-[#8A8A8A] w-max mb-3 text-[#F7941E]">
                        Netstratum Cloudstack
                    </div>
                    <div
                        className={` text-2xl md:text-4xl lg:text-5xl   font-custom font-bold`}
                    >
                        <div
                            dangerouslySetInnerHTML={{
                                __html: description?.Title1,
                            }}
                        />
                        {/* {description?.Title1} */}
                    </div>
                    <div
                        className={`text-2xl md:text-4xl lg:text-5xl md:mt-3  font-custom font-bold`}
                    >
                        {inView ? (
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: description?.Title2,
                                }}
                            />
                        ) : (
                            <div
                                className={` text-2xl md:text-4xl lg:text-5xl  font-custom font-bold`}
                            >
                                Development
                            </div>
                        )}
                    </div>

                    <div className={`lg:text-lg md:text-base  font-normal mt-3 pt-3`}>
                        {description?.Description1}
                    </div>
                    <div className={`lg:text-lg md:text-base   font-normal pt-3`}>
                        {description?.Description2}
                    </div>

                    {buttonLink ? (
                        <button
                            onClick={() => {
                                buttonLink[1]?.includes("https")
                                    ? window.open(buttonLink[1], "_blank", "noopener,noreferrer")
                                    : navigate(buttonLink);
                            }}
                            className=" bg-[#616161] text-white   border border-[#616161] hover:bg-white hover:text-[#616161] hover:border hover:border-[#616161] rounded-[50px] w-max px-4 py-2 my-6"
                        >
                            {buttonLink[0]}
                        </button>
                    ) : description?.ButtonText ? (
                        <button
                            onClick={() => {
                                navigate("/contact-us");
                            }}
                            className=" bg-[#F7941E] text-white border border-[#616161] hover:bg-white hover:text-[#F7941E] duration-300 hover:border hover:border-[#F7941E] rounded-[50px] w-max px-4 py-2 my-6"
                        >
                            {description?.ButtonText}
                        </button>
                    ) : null}
                </div>
                <div className="grid md:grid-cols-2 xl:grid-cols-1 py-5 xl:py-0">
                    {description?.introCards?.map((node: any, index: number) => {
                        return (
                            <div
                                key={index + node?.Title}
                                data-aos="fade-left"
                                data-aos-delay={`${index === 0 ? 150 : index * 150}`}
                                className={`  bg-white py-3 lg:p-3  flex items-start `}
                            >
                                <svg className="mr-2 pt-1" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M5.003 2.318C9.256 -0.773 15.016 -0.773 19.269 2.318C23.522 5.408 25.302 10.885 23.677 15.885C22.053 20.885 17.393 24.271 12.136 24.271C6.879 24.271 2.219 20.885 0.595 15.885C-1.03 10.885 0.75 5.408 5.003 2.318Z"
                                        stroke="url(#paint0_linear)"
                                        stroke-width="2"
                                        fill="none"
                                    />

                                    <defs>
                                        <linearGradient id="paint0_linear" x1="4" y1="3" x2="21" y2="22" gradientUnits="userSpaceOnUse">
                                            <stop offset="0%" stop-color="#D0D0D0" />
                                            <stop offset="90%" stop-color="#F08200" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                                <div>
                                    <div className="font-bold font-custom  md:text-base text-base   pb-1">
                                        {node?.Title}
                                    </div>
                                    <div className="font-custom md:text-base text-base ">
                                        {node?.Description}
                                    </div>
                                </div>

                            </div>
                        );
                    })}
                </div>

            </div>

        </div>

    );
}

export default CloudStackDevelopmentPageDescription;
